// @flow
// FlyerGrid Container
/* global window */

function getConfig(domain) {
  switch (domain) {
    case 'app.peachjar-kauai.com':
      return {
        REACT_APP_ENV: 'development',
        REACT_APP_API_HOST_NAME: 'https://flyers-bff.peachjar-kauai.com',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar-kauai.com',
        REACT_APP_PARENT_ACCOUNT_INFO_URI:
          'https://accounts.peachjar-kauai.com/parent/account-information',
        REACT_APP_BFF_ACCOUNTS_URL: 'https://accounts-bff.peachjar-kauai.com',
        REACT_APP_ACCOUNTS_APP_URL: 'https://accounts.peachjar-kauai.com',
        REACT_APP_PORTAL_BFF_GRAPHQL_URI: 'https://portal-bff.peachjar-kauai.com/graphql',
        REACT_APP_ACCOUNTS_BFF_GRAPHQL_URI:
          'https://accounts-bff.peachjar-kauai.com/graphql',
        REDIRECT_AFTER_LOGIN_URL: 'https://portal.peachjar-kauai.com/dashboard',
        REDIRECT_NEW_PARENT_APP_URL: 'https://parent-app.peachjar-kauai.com'
      }
    case 'app.peachjar.com':
      return {
        REACT_APP_ENV: 'production',
        REACT_APP_API_HOST_NAME: 'https://flyers-bff.peachjar.com',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar.com',
        REACT_APP_PARENT_ACCOUNT_INFO_URI:
          'https://accounts.peachjar.com/parent/account-information',
        REACT_APP_BFF_ACCOUNTS_URL: 'https://accounts-bff.peachjar.com',
        REACT_APP_ACCOUNTS_APP_URL: 'https://accounts.peachjar.com',
        REACT_APP_PORTAL_BFF_GRAPHQL_URI: 'https://portal-bff.peachjar.com/graphql',
        REACT_APP_ACCOUNTS_BFF_GRAPHQL_URI:
          'https://accounts-bff.peachjar.com/graphql',
        REDIRECT_AFTER_LOGIN_URL: 'https://portal.peachjar.com/dashboard',
        REDIRECT_NEW_PARENT_APP_URL: 'https://my.peachjar.com'
      }
    default:
      return {
        REACT_APP_ENV: 'development',
        REACT_APP_API_HOST_NAME: 'https://flyers-bff.peachjar.net:10443',
        V2_API_HOST_NAME: 'https://portal-bff.peachjar.net:10443',
        REACT_APP_PARENT_ACCOUNT_INFO_URI:
          'https://accounts.peachjar.net:10443/parent/account-information',
        REACT_APP_BFF_ACCOUNTS_URL: 'https://accounts-bff.peachjar.net:10443',
        REACT_APP_ACCOUNTS_APP_URL: 'https://accounts.peachjar.net:10443',
        REACT_APP_PORTAL_BFF_GRAPHQL_URI: 'https://portal-bff.peachjar.net:10443/graphql',
        REACT_APP_ACCOUNTS_BFF_GRAPHQL_URI:
          'https://accounts-bff.peachjar.net:10443/graphql',
        REDIRECT_AFTER_LOGIN_URL: 'https://portal.peachjar.net:10443/dashboard',
        REDIRECT_NEW_PARENT_APP_URL: 'https://parent-app.peachjar.net:10443'
      }
  }
}

export default getConfig(window.location.hostname)



// WEBPACK FOOTER //
// ./src/config.js